import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useDeleteRoom() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (roomId: number) =>
      apiMutation('DELETE', {
        path: ENDPOINTS.deleteRoom,
        params: { id: roomId.toString() },
      }) as Promise<void>,
    onSuccess: (_, roomId) => {
      message.success(`Room #${roomId} successfully deleted`);

      queryClient.removeQueries({
        queryKey: [CORE_QUERY_KEYS.room, { id: roomId.toString() }],
      });

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.rooms],
      });
    },
    onError: () => {
      message.error('Failed to delete room. Room may be in use.');
    },
  });
}
